import { ClassNamesConfig } from "react-select";

export const primarySelectClassNames: ClassNamesConfig = {
  control: ({ isFocused }) =>
    `!font-semibold !text-gray-800 !cursor-pointer ${isFocused ? "!border-primary-200" : "!border-gray-300"} !rounded-lg`,
  container: () => "mt-1",
  option: ({ isSelected }) =>
    `${isSelected ? "!bg-primary-200" : "hover:!bg-primary-50"} !text-black !cursor-pointer`,
};
